import React from 'react';
import useMe from '../../../hooks/useMe';
import NavigationMenu from './NavigationMenu';
import {Alert, Box, BoxProps, Button, Text} from 'components/ui/chakra';
import AdminController from 'puddleglum/api/admin/AdminController';

interface PageProps extends BoxProps {
	children: React.ReactNode;
}

const Page = ({children, ...rest}: PageProps) => {
	const {me} = useMe();

	const handleImpersonationLogout = async () => {
		await AdminController.impersonationLogOut();
		window.location.reload();
	};

	return (
		<Box minH='100vh' position='relative' {...rest}>
			<Box
				background='linear-gradient(180deg, rgba(255, 253, 249, 0.78) 0%, rgba(248, 225, 216, 0.34) 100%)'
				inset={0}
				position='fixed'
				pointerEvents='none'
				zIndex={-1}
			/>
			<Box
				backdropFilter={{base: 'none', md: 'blur(18px)'}}
				background={{base: 'white', md: 'rgba(255, 253, 249, 0.86)'}}
				borderBottom='1px solid'
				borderColor='border'
				left={0}
				position='fixed'
				right={0}
				top={0}
				zIndex='sticky'
			>
				<NavigationMenu />
			</Box>

			{me?.is_impersonating === true && (
				<Alert
					borderRadius='full'
					justifyContent='center'
					left={4}
					position='fixed'
					right={4}
					status='warning'
					top={{base: '5.5rem', md: '6rem'}}
					zIndex='toast'
				>
					<Text pr={4}>
						You are impersonating user {me.first_name} {me.last_name}.
					</Text>
					<Button onClick={handleImpersonationLogout} size='sm' colorScheme='red'>
						Log out
					</Button>
				</Alert>
			)}
			<Box pt={{base: '5.5rem', md: '6.5rem'}}>{children}</Box>
		</Box>
	);
};

export default Page;
